import { notification } from 'antd'
import store from 'store'

import { store as reduxStore } from 'index'

import { clientForLanding, restLandingClient } from 'myNet'

import Ngql from 'gql/ninegql'
import { processError } from 'utils'

const mutationUpdataProviderToken = Ngql.Mutation('obtainAccessToken', {
  obtainAccessToken: Ngql.Node(
    {
      ok: true,
      accessToken: true,
      expiresAt: true,
      // payload: true
    },
    null,
    false,
    {
      // refreshToken: Ngql.Var('refreshToken', 'String!'),
    },
  ),
})

const updateInfo = {
  isUpdating: false,
  currentQuery: null,
  waitingReq: [],
}

export function updateToken() {
  const refreshToken = store.get('app.user.refreshToken')

  let ret = null
  if (refreshToken != null) {
    if (updateInfo.isUpdating === false) {
      store.remove('app.user.token')
      updateInfo.isUpdating = true
      // FIXME : officeNextClient 사용
      updateInfo.currentQuery = restLandingClient
        .post('/auth/refresh', {
          // access_token: accessToken,
          // service_group_code: 'officemail-migration',
          // provider: 'officenext',
          refresh_token: refreshToken,
        })
        .then((res) => {
          // FIXME: data 값 확인하기
          const { data } = res.data
          console.log(' updateToken - res : ', res)
          store.set('app.user.token', data.access_token)
          store.set('app.user.refreshExpiresIn', data.expires_in)
          store.set('app.user.refreshToken', data.refresh_token)

          console.log(' updateToken - success : ', updateInfo.waitingReq.length)
          updateInfo.waitingReq.forEach((promise) => {
            promise.resolve(data.access_token)
          })
          updateInfo.waitingReq = []

          updateInfo.isUpdating = false
          updateInfo.currentQuery = null
          return data.access_token
        })
        .catch((err) => {
          console.log(' updateToken - fail : ', updateInfo.waitingReq.length, err)
          updateInfo.waitingReq.forEach((promise) => {
            promise.reject()
          })

          updateInfo.waitingReq = []
          updateInfo.isUpdating = false
          updateInfo.currentQuery = null

          if (err.cause != null) {
            const { statusCode, result } = err.cause
            const { errors } = result
            console.log(' ==== updateToken - errors ', statusCode, errors)

            // 명시적으로 인증 관련 에러인 경우에만 로그아웃 처리
            // 인증 실패 또는 토큰 만료.
            if (statusCode === 401 || statusCode === 402) {
              reduxStore.dispatch({
                type: 'user/LOGOUT',
              })
            }
          }
        })

      ret = updateInfo.currentQuery
    } else {
      const retPromise = new Promise((resolve, reject) => {
        updateInfo.waitingReq.push({
          resolve,
          reject,
        })
      })
      ret = retPromise
    }
  }
  return ret
}

function callUpdateToken(uri, options) {
  let retPromise = null
  let ret = false

  const updateHandle = updateToken()
  if (updateHandle != null) {
    retPromise = new Promise((resolve, reject) => {
      updateHandle
        .then((token) => {
          console.log(' new token : ', token)
          if (token != null) {
            options.headers.authorization = `JWT ${token}`
            console.log(' ==== call After token Updated - ', uri, options)
            let responseData = null
            fetch(uri, options)
              .then((response) => {
                responseData = response
                if (response.status !== 204 && response.status !== 304) {
                  // content가 없거나, not modified면 에러발생.
                  const jsonData = response.clone().json()
                  console.log(' ==== fetch result ', response, jsonData)
                  return jsonData
                }
                return null
              })
              .then((jsonBody) => {
                // restAPI 호출 시 activity 수집을 위해 401 status 대신 200 status와 error code 401을 반환하도록 함.
                if (responseData.status >= 400 && jsonBody && jsonBody.code !== 200) {
                  const error = jsonBody
                  processError(error, (code, message) => {
                    const err = new Error(message)
                    err.code = code
                    reject(err)
                  })
                }

                return responseData
              })
              .then((res2) => {
                console.log(' ==== uri, res2 - ', uri, res2)
                resolve(res2)
              })
          }
        })
        .catch(() => {
          reject()
        })
    })
    ret = true
  }

  return {
    retPromise,
    ret,
  }
}

export function customFetchWithToken(uri, options) {
  let isTokenEmpty = null
  const token = store.get('app.user.token')
  if (token == null || token.trim().length === 0) {
    // throw new Error('authLink - empty token..!')
    isTokenEmpty = true
  }

  return customFetch(uri, options, isTokenEmpty)
}

export function customFetch(uri, options, isTokenEmpty) {
  console.log(' ==== customFetch ', uri, options, isTokenEmpty, this)
  // This reference to the refreshingPromise will let us check later on if we are executing getting the refresh token.
  // Create initial fetch, this is what would normally be executed in the link without the override

  if (isTokenEmpty === true) {
    console.log(' ==== customFetch - token is Empty~! ')
    const callRet = callUpdateToken(uri, options)
    return callRet.retPromise
  }

  const initialRequest = fetch(uri, options)

  let responseData = null
  // The apolloHttpLink expects that whatever fetch function is used, it returns a promise.
  // Here we return the initialRequest promise
  return initialRequest
    .then((response) => {
      responseData = response
      if (response.status !== 204 && response.status !== 304) {
        // content가 없거나, not modified면 에러발생.
        const ret = response.clone().json()
        console.log(' ==== fetch result ', response, ret)
        return ret
      }
      return null
    })
    .then((jsonBody) => {
      // restAPI 호출 시 activity 수집을 위해 401 status 대신 200 status와 error code 401을 반환하도록 함.
      if (
        (responseData.status >= 400 && jsonBody && jsonBody.code !== 200) ||
        (responseData.status === 200 && jsonBody && jsonBody.code === 401)
      ) {
        const error = jsonBody
        let ret = {}
        processError(error, (code, message) => {
          if (
            code === 401 ||
            message.indexOf('Signature has expired') > -1 ||
            message.indexOf('jwt expired') > -1
          ) {
            console.log(' !!! Signature has expired ')
            ret = callUpdateToken(uri, options)
            if (ret.retPromise == null) {
              notification.warning({
                message: code,
                description: message,
              })
            }

            // } else if (message.indexOf('Unauthenticated token') > -1) {
            //   if (window.parent === window) {
            //     setLoginVisible(true)
            //   } else {
            //     window.parent.nPopup.setLoginVisible(true)
            //   }
            //   return true
            // }
          } else if (code === 500 || message === 'Not authenticated') {
            // @todo : office addin에서 동작 중 문제가 발생하면, office email로 로그인 할 수 있도록 경로를 지정해야 함.

            // reduxStore.dispatch({
            //   type: 'user/LOGOUT',
            // })
            throw new Error(message)
          } else if (code === 400) {
            const err = new Error(message)
            err.code = code
            throw err
          }
          return ret.ret
        })

        if (ret.retPromise != null) {
          return ret.retPromise
        }

        // if (isError === true) {
        //   const err = new ApolloError();
        //   err.code = error.code;
        //   err.errors = error.errors;
        //   throw err;
        // }
      }

      return responseData
    })
  // .catch((error) => {
  //   console.log(' ==== fetch error ', error)
  //   return error
  // })
}

const updateInfoForProvider = {
  isUpdating: false,
  currentQuery: null,
  waitingReq: [],
}

export function updateTokenForProvider() {
  const refreshToken = store.get('app.user.refreshToken')
  let ret = null
  if (refreshToken != null) {
    if (updateInfoForProvider.isUpdating === false) {
      store.remove('app.user.token')
      updateInfoForProvider.isUpdating = true
      // store.set('app.user.token', refreshToken)
      updateInfoForProvider.currentQuery = Ngql.GQLObj(mutationUpdataProviderToken, {
        // vars: {
        //   refreshToken,
        // },
      })
        .mutate({}, clientForLanding)
        .then((res) => {
          store.set('app.user.providerToken', res.data.obtainAccessToken.accessToken)
          store.set('app.user.providerTokenExpiresAt', res.data.obtainAccessToken.expiresAt)

          updateInfoForProvider.waitingReq.forEach((promise) => {
            promise.resolve(res.data.obtainAccessToken.accessToken)
          })
          updateInfoForProvider.waitingReq = []

          updateInfoForProvider.isUpdating = false
          updateInfoForProvider.currentQuery = null
          return res.data.obtainAccessToken.accessToken
        })
        .catch((error) => {
          console.log(' updateProviderToken - fail : ', updateInfoForProvider.waitingReq.length)
          updateInfoForProvider.waitingReq.forEach((promise) => {
            promise.reject()
          })
          updateInfoForProvider.waitingReq = []

          updateInfoForProvider.isUpdating = false
          updateInfoForProvider.currentQuery = null

          if (error.cause != null) {
            const { statusCode, result } = error.cause
            const { errors } = result
            console.log(' ==== updateProviderToken - errors ', statusCode, errors)

            // 명시적으로 인증 관련 에러인 경우에만 로그아웃 처리
            // 인증 실패 또는 토큰 만료.
            if (statusCode === 401 || statusCode === 402) {
              reduxStore.dispatch({
                type: 'user/LOGOUT',
              })
            }
          }
        })

      ret = updateInfoForProvider.currentQuery
    } else {
      const retPromise = new Promise((resolve, reject) => {
        updateInfoForProvider.waitingReq.push({
          resolve,
          reject,
        })
      })
      ret = retPromise
    }
  }
  return ret
}

function callUpdateTokenForProvider(uri, options) {
  let retPromise = null
  let ret = false

  const updateHandle = updateTokenForProvider()
  if (updateHandle != null) {
    retPromise = new Promise((resolve, reject) => {
      updateHandle
        .then((providerToken) => {
          console.log(' new providerToken : ', providerToken)
          if (providerToken != null) {
            options.headers.authorization = `Bearer ${providerToken}`
            console.log(' ==== call After token Updated - ', uri, options)
            fetch(uri, options).then((res2) => {
              resolve(res2)
            })
          }
        })
        .catch(() => {
          store.remove('app.user.providerToken')
          reject()
        })
    })
    ret = true
  }

  return {
    retPromise,
    ret,
  }
}

export function customFetchWithProviderToken(uri, options) {
  let isTokenEmpty = null
  const token = store.get('app.user.providerToken')
  if (token == null || token.trim().length === 0) {
    // throw new Error('authLink - empty token..!')
    isTokenEmpty = true
  }

  return customFetchForProvider(uri, options, isTokenEmpty)
}

export function customFetchForProvider(uri, options, isTokenEmpty) {
  console.log(' ==== customFetch ', uri, options, isTokenEmpty, this)
  // This reference to the refreshingPromise will let us check later on if we are executing getting the refresh token.
  // Create initial fetch, this is what would normally be executed in the link without the override

  if (isTokenEmpty === true) {
    console.log(' ==== customFetch - token is Empty~! ')
    const callRet = callUpdateTokenForProvider(uri, options)
    return callRet.retPromise
  }

  const initialRequest = fetch(uri, options)

  let responseData = null
  // The apolloHttpLink expects that whatever fetch function is used, it returns a promise.
  // Here we return the initialRequest promise
  return initialRequest
    .then((response) => {
      responseData = response
      if (response.status !== 204 && response.status !== 304) {
        // content가 없거나, not modified면 에러발생.
        const ret = response.clone().json()
        console.log(' ==== fetch result ', response, ret)
        return ret
      }
      return null
    })
    .then((jsonBody) => {
      if (responseData.status >= 400 && jsonBody && jsonBody.code !== 200) {
        const error = jsonBody
        let ret = {}
        processError(error, (code, message) => {
          if (
            code === 401 ||
            message.indexOf('Signature has expired') > -1 ||
            message.indexOf('jwt expired') > -1
          ) {
            console.log(' !!! Signature has expired ')
            ret = callUpdateTokenForProvider(uri, options)
            if (ret.retPromise == null) {
              notification.warning({
                message: code,
                description: message,
              })
            }

            // } else if (message.indexOf('Unauthenticated token') > -1) {
            //   if (window.parent === window) {
            //     setLoginVisible(true)
            //   } else {
            //     window.parent.nPopup.setLoginVisible(true)
            //   }
            //   return true
            // }
          } else if (code === 500 || message === 'Not authenticated') {
            // @todo : office addin에서 동작 중 문제가 발생하면, office email로 로그인 할 수 있도록 경로를 지정해야 함.
            // reduxStore.dispatch({
            //   type: 'user/LOGOUT',
            // })
            throw new Error(message)
          }
          return ret.ret
        })

        if (ret.retPromise != null) {
          return ret.retPromise
        }

        // if (isError === true) {
        //   const err = new ApolloError();
        //   err.code = error.code;
        //   err.errors = error.errors;
        //   throw err;
        // }
      }

      return responseData
    })
    .catch((error) => {
      console.log(' ==== fetch error ', error)
      return error
    })
}

export async function login() {
  // return Ngql.GQLObj(mutationLogin, {
  //   vars: {
  //     email,
  //     password,
  //     serverType: 'exchange',
  //     serverUri: 'mail.ninefolders.xyz',
  //   },
  //   useUI: false,
  // })
  //   .mutate()
  //   .then((res) => {
  //     store.set('app.user.token', res.data.tokenAuth.token)
  //     store.set('app.user.refreshExpiresIn', res.data.tokenAuth.refreshExpiresIn)
  //     store.set('app.user.refreshToken', res.data.tokenAuth.refreshToken)
  //     return true
  //   })
  //   .catch((error) => {
  //     updateInfo.params = null
  //     notification.warning({
  //       message: error.code,
  //       description: error.message,
  //     })
  //   })
}

export async function loginByOTP() {
  // not implement.
}

export async function loginByKey() {
  // not implement.
}

// const queryUserInfo = Ngql.Query('userInfo', {
//   // me: Ngql.Node({
//   //   id: true,
//   //   email: true,
//   //   username: true,
//   //   avatarUrl: true,
//   //   ewsUri: true,
//   //   authType: true,
//   //   provider: true,
//   //   protocol: true,
//   //   version: true,
//   //   createdAt: true,
//   //   updatedAt: true,
//   // }),
//   // systemInfo: Ngql.Node({
//   //   appName: true,
//   //   description: true,
//   //   adminEmail: true,
//   //   version: true,
//   //   locale: true,
//   //   timezone: true,
//   // }),
//   adminEmail: true,
//   serverType: true,
// })

export async function register(/* email, password, name */) {
  // function fakeRegister() {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve(true)
  //     }, 200)
  //   })
  // }
  // return fakeRegister()
}

export async function currentAccount() {
  // const token = store.get('app.user.token')
  // if (token && token.length > 0) {
  //   return Ngql.GQLObj(queryUserInfo, {
  //     useUI: false,
  //   })
  //     .query()
  //     .then((res) => {
  //       console.log(' ---- ', res)
  //       setEnvParam('serverType', res.data.serverType)
  //       reduxStore.dispatch({
  //         type: 'menu/RELOAD',
  //       })
  //       if (res.data.adminEmail == null) {
  //         const tokenInfo = parseJwt(token)
  //         return {
  //           name: '',
  //           uid: '',
  //           email: tokenInfo.email,
  //           photoURL: '',
  //           role: 'admin',
  //           lastLogin: '',
  //           serverType: res.data.serverType,
  //         }
  //       }
  //       return {
  //         name: 'Administrator',
  //         uid: '',
  //         email: res.data.adminEmail,
  //         // photoURL: res.data.me.avatar,
  //         role: 'admin',
  //         lastLogin: '',
  //         serverType: res.data.serverType,
  //       }
  //     })
  //     .catch((error) => {
  //       if (error) {
  //         console.log(' ---- ', error)
  //         if (error.code !== 401) {
  //           notification.warning({
  //             message: error.code,
  //             description: error.message,
  //           })
  //         }
  //       }
  //     })
  // }
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve(false)
  //   }, 200)
  // })
}

export async function logout() {
  // return firebaseAuth()
  //   .signOut()
  //   .then(() => true)
  // function fakeLogout() {
  //   store.remove('app.user.token')
  //   store.remove('app.user.refreshToken')
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve(true)
  //     }, 200)
  //   })
  // }
  // return fakeLogout()
}

const jwt = {
  customFetch,
  login,
  logout,
}

export default jwt
